import { render, staticRenderFns } from "./v-pagination.vue?vue&type=template&id=57ca07f0&scoped=true"
import script from "./v-pagination.vue?vue&type=script&lang=js"
export * from "./v-pagination.vue?vue&type=script&lang=js"
import style0 from "./v-pagination.vue?vue&type=style&index=0&id=57ca07f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ca07f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VPagination,VSelect,VTextField})
